export default __webpack_public_path__ + "static/media/ad__amp__d_offer_dark.bfd28127.png";